import { render } from "./PrintDocumentConfirmationDialog.vue?vue&type=template&id=fe9b7576&scoped=true&ts=true"
import script from "./PrintDocumentConfirmationDialog.vue?vue&type=script&lang=ts"
export * from "./PrintDocumentConfirmationDialog.vue?vue&type=script&lang=ts"

import "./PrintDocumentConfirmationDialog.vue?vue&type=style&index=0&id=fe9b7576&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fe9b7576"]])

export default __exports__
import QDialog from 'quasar/src/components/dialog/QDialog.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QDialog,QBtn});
